import { ColumnDef, ColumnHelper } from '@tanstack/react-table'
import { Stack } from '@mui/material'

import { commonAccessorColumn, moneyAccessorColumn } from '@/components/table'
import { SendUrlButton } from '@/components'
import { TemplatePayment } from '@/types.ts'
import { TEMPLATES_ENDPOINTS } from '@/services'
import { DeleteTemplateButton } from '@/pages/template-payments/components'

export const KEY_PAGE = 'templates'

type VisibleColumns = 'id' | 'paymentInfoShort' | 'amount' | 'paymentCountLimit' | 'createTime' | 'validTo'

export type PartialTemplates = Pick<TemplatePayment, VisibleColumns>

export const defaultSettings: Record<keyof PartialTemplates, string> = {
  id: '№ платежа',
  paymentInfoShort: 'Название товара/услуги',
  amount: 'Сумма',
  paymentCountLimit: 'Лимит платежей',
  createTime: 'Дата создания',
  validTo: 'Действительна до',
}

export function getColumnsSettings(
  columnHelper: ColumnHelper<TemplatePayment>
): Record<keyof PartialTemplates, ColumnDef<TemplatePayment, any>> {
  return {
    id: columnHelper.accessor('id', commonAccessorColumn('№ платежа')),
    paymentInfoShort: columnHelper.accessor('paymentInfoShort', commonAccessorColumn('Название товара/услуги', true)),
    amount: columnHelper.accessor('amount', moneyAccessorColumn('Сумма')),
    paymentCountLimit: columnHelper.accessor('paymentCountLimit', commonAccessorColumn('Лимит платежей')),
    createTime: columnHelper.accessor('createTime', commonAccessorColumn('Дата создания')),
    validTo: columnHelper.accessor('validTo', commonAccessorColumn('Действительна до')),
  }
}

export const getStaticColumns = (
  columnHelper: ColumnHelper<TemplatePayment>
): Record<string, ColumnDef<TemplatePayment, any>> => {
  return {
    'template-actions': columnHelper.display({
      id: 'template-actions',
      enableSorting: false,
      cell: (props) => (
        <Stack direction="row" spacing={2} alignItems="center">
          <SendUrlButton {...props.row.original} sendUrl={TEMPLATES_ENDPOINTS.sendUrl} />
          <DeleteTemplateButton {...props.row.original} />
        </Stack>
      ),
    }),
  }
}
